import { render, staticRenderFns } from "./LessonSettings.vue?vue&type=template&id=379a4dc3"
import script from "./LessonSettings.vue?vue&type=script&lang=js"
export * from "./LessonSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports